'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNil = require('coact-utils/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creator = {
  number: function number(_ref) {
    var format = _ref.format;
    return function numberFormatter(value) {
      if ((0, _isNil2.default)(value)) return '';
      if (!format) return '' + value;
      return (0, _numeral2.default)(value).format(format);
    };
  },
  date: function date(_ref2) {
    var format = _ref2.format;
    return function dateFormatter(value) {
      if ((0, _isNil2.default)(value)) return '';
      return (0, _moment2.default)(value).format(format);
    };
  },
  array: function array(_ref3) {
    var separator = _ref3.separator;
    return function arrayFormatter(value) {
      if ((0, _isNil2.default)(value)) return '';
      return value.join(separator);
    };
  },
  object: function object(_ref4) {
    var joinKeys = _ref4.joinKeys,
        separator = _ref4.separator;
    return function objectFormatter(value) {
      if ((0, _isNil2.default)(value)) return '';
      if (joinKeys) return joinKeys.map(function (key) {
        return value[key];
      }).join(separator);
      return JSON.stringify(value);
    };
  },
  default: function _default() {
    return function defaultFormatter(value) {
      if ((0, _isNil2.default)(value)) return '';
      if (value instanceof Date) return (0, _moment2.default)(value).format();
      return '' + value;
    };
  }
}; /*
     formatter 因為會影響最後 view 的 props，所以不應該是個 handler
     因為 handler，在每次的 render 中 reference，並不會改變
     若是影響 formatter 結果的 props 在中途被 consume 了
     formatter 的 reference 又不變，則 shouldUpdate 的判斷可能會錯誤
   
     每次依 props 判斷要不要重新產生 formatter
     handler 為每次 render 都重新產生 func，但只是把 props 包進 closure
     產生一個 func 與 判斷 props 是否一致，兩者不知道效率的差異
     */

function makeFormatter(spec) {
  var _spec$type = spec.type,
      type = _spec$type === undefined ? 'default' : _spec$type,
      elementType = spec.elementType;


  var valueType = elementType || type;

  var formatter = (creator[valueType.toLowerCase()] || creator.default)(spec);

  if (elementType) {
    var elementSeparator = spec.elementSeparator;

    return function elementFormatter(value) {
      return value && value.map(formatter).join(elementSeparator);
    };
  }

  return formatter;

  /*  When value is an array, recuersive call `formatter`(not `format`)
      - 處理 array of array
      - 可以讓 `isNil` 的檢查移到 formatter 裡，不用在每個 typeFormatter 中檢查
      */
  // return function formatter (value) {
  //   if (isNil(value)) return ''
  //   if (isArray(value)) return value.map(formatter).join(separator)
  //   return format(value)
  // }
}

var specKeys = ['type', 'format', 'joinKeys', 'separator', 'elementSeparator', 'elementType'];
function isEqualSpec(a, b) {
  for (var i = 0; i < specKeys.length; i++) {
    if (a[specKeys[i]] !== b[specKeys[i]]) return false;
  }
  return true;
}

makeFormatter.isEqualSpec = isEqualSpec;
makeFormatter.specKeys = specKeys;
exports.default = makeFormatter;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/makeFormatter/index.js
// module id = 1682
// module chunks = 0